module.exports = __webpack_public_path__ + "media/images/menu-a5f7f601f1affe14be378887218f064b.svg";